import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUserUID, deleteUserAccount } from '../utilities/authUtils';
import PageContainer from '../../PageUtil/PageContainer';

const DeleteAccount = () => {
  const [confirmEmail, setConfirmEmail] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userId, setUserId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      setUserEmail(user.email);
      setUserId(user.uid);
    } else {
      navigate('/login');
    }
  }, [navigate]);

  const handleDelete = async (e) => {
    e.preventDefault();
    
    if (confirmEmail !== userEmail) {
      setError('Email does not match');
      return;
    }

    if (!isConfirmed) {
      setError('Please check the confirmation box');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await deleteUserAccount(userId);
      alert('Your account and all associated data have been permanently deleted.');
      navigate('/register');
    } catch (err) {
      console.error('Error deleting account:', err);
      setError(err.message || 'Failed to delete account. You may need to re-login to perform this sensitive action.');
      setLoading(false);
    }
  };

  return (
    <PageContainer error={error} setError={setError}>
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            <div className="card border-danger shadow">
              <div className="card-header bg-danger text-white py-3">
                <h3 className="card-title mb-0">Delete Account</h3>
              </div>
              <div className="card-body p-4">
                <div className="alert alert-warning">
                  <h5><i className="bi bi-exclamation-triangle-fill me-2"></i>Warning: Irreversible Action</h5>
                  <p className="mb-0">
                    Deleting your account will permanently remove:
                  </p>
                  <ul className="mt-2">
                    <li>Your profile information</li>
                    <li>All your draft and published portfolios</li>
                    <li>All images you have uploaded</li>
                    <li>All project and skill entries</li>
                  </ul>
                  <p className="mb-0 fw-bold">This action cannot be undone.</p>
                </div>

                <form onSubmit={handleDelete} className="mt-4">
                  <div className="mb-4">
                    <label htmlFor="confirmEmail" className="form-label">
                      To confirm, type your email address (<strong>{userEmail}</strong>):
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="confirmEmail"
                      value={confirmEmail}
                      onChange={(e) => setConfirmEmail(e.target.value)}
                      placeholder="Enter your email"
                      required
                      disabled={loading}
                    />
                  </div>

                  <div className="mb-4 form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="confirmCheckbox"
                      checked={isConfirmed}
                      onChange={(e) => setIsConfirmed(e.target.checked)}
                      required
                      disabled={loading}
                    />
                    <label className="form-check-input-label ps-2" htmlFor="confirmCheckbox">
                      I understand that this is permanent and my data will be lost forever.
                    </label>
                  </div>

                  <div className="d-flex gap-3 mt-4">
                    <button
                      type="button"
                      className="btn btn-outline-secondary flex-grow-1"
                      onClick={() => navigate('/dashboard')}
                      disabled={loading}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-danger flex-grow-1"
                      disabled={loading || confirmEmail !== userEmail || !isConfirmed}
                    >
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Deleting...
                        </>
                      ) : (
                        'Delete My Account'
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default DeleteAccount;
